module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-know"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("江西风向标智能科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("\n      产品服务协议（知了家长）\n    ")])]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("\n    尊敬的用户：\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    您好！欢迎您使用江西风向标智能科技有限公司（以下简称“风向标”或“服务商”）出品的“知了家长”产品及配套服务。为使您的使用过程便捷，准确提升产品使用效率，请您认真阅读本协议，\n    您在阅读并确认使用上述产品后即表示您同意本协议的内容。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    江西风向标智能科技有限公司（以下简称“风向标”或“服务商”、“公司”）为您（指通过登录APP或网站、公众号、小程序等方式购买并使用风向标“知了家长”产品及配套服务的终端客户，以下也称为“用户”）提供“知了家长”产品和配套服务（以下简称“本产品”、“产品”），您自愿购买上述产品并基于购买产品后的使用而作出如下意思表示和授权，以下意思表示及授权均为您真实意愿，您同意承担由此带来的一切风险和责任。如果您是未成年人，则请您在法定监护人陪同下审阅和判断是否同意本协议的内容，未成年人使用本产品的行为视为已获得了法定监护人的认可。如果您不同意接受本协议的全部条款，则您无权注册、登录或使用本协议所涉及产品和服务，您下载、安装、使用本产品等行为，则意味着您将自愿遵守本协议及本产品的其他有关规则，并完全服从于本产品的统一管理。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    风向标有权根据业务需要对本协议不定时进行调整，并将调整后的协议公布于公司官网或者产品APP、公众号、小程序中，如果您不同意调整后的本协议的，您应当停止使用本产品，否则，如果在公司调整本协议并公布后，您继续使用本产品提供的服务的，则视为您同意遵守调整后的协议。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("一、关于购买产品")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、用户系自愿购买本产品，并通过线上或线下的方式向风向标支付用以购买产品的费用，用户用以登录产品使用端口的账号来自风向标的授予。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、用户已具备与购买行为相适应的智力、健康状况，或经用户的法定监护人的同意购买本产品，并充分理解、知悉购买产品和使用产品行为产生的法律效果以及基于购买和使用产品的行为产生的个人信息采集情况。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3、经风向标许可，用户使用试用账号登录产品使用端口，并不表示用户同意即时付费，但这并不影响为正常使用产品而授权风向标采集用户的个人信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、产品的试用期限届满后，用户无意付费购买的，用户同意风向标随时收回风向标授予本人的登录账号。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("二、用户权利和义务")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、用户应妥善保管自己的账号、密码，不得转让、出借、出租、出售或分享予他人使用。否则风向标有权根据实际情况暂时封停或永久查封此账号，当用户的账号或密码遭到未经授权的使用时，用户应当立即通知风向标，否则未经授权的使用行为均视为用户本人行为。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、风向标有权随时对本产品内容等进行调整，包括但不限于增加、删除、修改本产品服务内容，一旦本产品的服务内容发生增加、删除、修改，公司将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用本产品提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用本产品内新增的服务内容将同样受本协议各项条款的约束。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、本产品内提供的服务分为试用期间的免费服务和正式使用的收费服务。对于现阶段免费提供的服务内容，公司有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，公司将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，公司有权自行确定该等服务的价格并不时调整，调整后的价格将在本产品平台中进行公示或以其他方式告知用户，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在公司调整价格并公示或告知后，仍继续购买收费服务的，则视为用户同意该调整后的价格。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    4、用户如对付费购买的服务不满意的，有权终止服务。用户需在规定时间内，在客户端自行申请或拨打客服电话，申请终止服务及退款，退款金额按照客户端公示的退款规则计算，公司有权根据业务发展不时调整退款规则并在客户端内公示；公司有权保留已终止服务的用户的所有使用信息，对用户在使用付费服务期间发生的违反本协议及相关规定的行为，公司仍有权行使本协议规定的权利并追究用户的法律责任。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    5、公司不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以本产品平台上的实时信息为准，用户知悉并认可，公司有权自行决定是否提供优惠政策或开展优惠互动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("6、公司禁止以任何形式倒卖、贩售、出租、出借、转让用户账号的行为，一经查明，公司将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("三、平台管理")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、用户应保证注册、登录并使用的账号符合中国相关法律法规的规定，符合《互联网用户账号名称管理规定》，符合本协议的各项规定。公司有权对用户注册、登录并使用的账号名称、头像和简介等注册信息进行审核，用户确保其使用的用户账号名称、头像和简介等信息中不得出现违法和不良信息，不存在以虚假信息骗取账号名称注册的情形；用户应确保其使用的用户账号名称不得为冒用关联机构或社会名人注册的账号名称。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、如果用户以虚假信息骗取账号名称注册，或用户的账号头像、简介等注册信息存在违法和不良信息的，公司有权采取通知限期改正、暂停使用、注销登记等措施；如果用户冒用关联机构或社会名人注册账号名称的，公司有权注销用户的账号，并向互联网信息内容主管部门报告。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、凡用户存在发布广告、暴力、色情、政治、宗教等内容，或抄袭、模仿管理人员ID，用以假冒管理人员或破坏管理人员形象，或模仿或盗用他人ID个人签名，发布的内容包含有严重影响网友浏览的内容或格式，或者存在其他扰乱本产品秩序的，或影响公司正常经营行为的，公司有权删除其相应账号，情节严重者，将酌情封禁对应IP。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、公司提供账号注销功能，可以在本产品中实现。注销账号之后此账号内的数据无法恢复，账号信息内容也将全部清除，包含但不限于该账号发布过的文章、评论等。注销行为操作后无法撤销，请用户谨慎申请。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    5、投诉和举报：如果用户认为本产品中的信息、资料、内容等存在违反法律法规及本产品相关管理规定的，涉嫌侮辱或者诽谤他人，或者侵犯用户或第三方的知识产权或其他合法权利情形的，您可以通过本产品内的专用渠道进行举报、投诉，或者向公司官方邮箱info@fxbjy.com发送权利通知书，公司将在收到您的投诉后将依据中国法律法规和政府规范性文件及本产品平台管理规定采取措施进行处理，包括但不限于移除相关内容或屏蔽相关链接，以及其他公司认为适当的处理方式，情节严重者，公司有权向政府相关部门进行举报。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("四、知识产权")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    1、无论您成为本产品之会员或使用本产品，均认可公司对本产品及本产品所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于用户个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意公司对您提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    2、如您将信息公布到本产品的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本产品不可撤销的、永久的、非独占的、完全免费的、中华人民共和国范围的许可。在该等许可下，您同意本产品使用、复制、执行、显示并传播该内容，您也同意公司基于该内容创作衍生作品或将该内容整合到其他作品中且公司对该等衍生作品或整合作品拥有完全的所有者权益。除已获得公司书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本产品收集、制作、发布的各类信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    3、请勿擅自复制或采用本产品所创造的用以制成网页的HTML。公司对其HTML享有著作权。同时，公司对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经公司同意，不得擅自复制、使用或转载。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、未经公司事先许可，禁止使用任何机器人、爬虫程序、其他自动设备，或手动程序等来监视或复制本产品网页或其所包含的任何内容。否则，公司有权依法追究法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("五、关于个人隐私和信息采集")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（一）信息采集授权")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、采集途径。您不可撤销地授权风向标以为您提供产品之目的，通过以下途径获取本人信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（1）您确认，您在申请试用和正式使用本产品小程序时，向风向标提供的信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（2）您在试用和正式使用产品后，风向标向您的被监护人所在学校班级任课老师和您提供的作业数据、考试数据、学习状况、在校情况等信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、采集范围。您不可撤销地授权风向标以为您提供产品及服务之目的，获取您个人以下范围的信息：")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（1）您申请试用产品时提交的姓名、手机号、被监护人的所在学校、年级、班级、学号、考号、姓名等等必要信息；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（2）您使用产品后通过产品系统上传的个人考卷、答题本、作业集、错题本以及历次考试成绩等；")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("（3）被监护人所在学校班级老师通过本产品教师端获取的被监护人的作业数据、考试数据、测评报告等。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（二）信息使用授权")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    您同意并不可撤销地授权风向标以为您提供产品之目的，保存、整理、加工本协议第五条第一款所述的、通过合法途径采集的您的信息，用于您更好的使用产品，以及辅助老师教学，并基于此目的，授权风向标通过本产品教师端向您所在学校和班级老师推送上述信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("上述授权系您对风向标做出的单方承诺，效力具有独立性，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("以上授权期限为您作出本授权承诺之日起至您在风向标处所有业务终结之日止。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（三）信息使用共享")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n    您授权风向标，除法律另有规定之外，将您提供给风向标的信息、使用产品产生的信息以及风向标根据本协议约定查询、收集的信息，用于风向标及其因服务必要委托的合作伙伴为您提供服务、推荐产品、开展市场调查以及信息数据分析。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("您授权风向标，除法律另有规定外，基于为您提供更优质服务和产品的目的，向风向标因服务必要开展合伙的伙伴提供、查询、收集您的信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("为确保您的个人信息安全，风向标对上述信息负有保密义务，并尽最大努力采取各种措施保证信息安全。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("本条款自您签署或确认本协议时生效，具有独立法律效力，不受本条款所属协议成立与否及效力状态的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title"
  }, [_vm._v("（四）用户知悉")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    包含您的被监护人的姓名、所在学校、年级、班级、学号、考号等信息为您的被监护人的个人信息。您应充分了解并明确知悉风向标向第三方采集并在法律法规许可范围内向信息使用者提供这些信息后，信息被其他主体对外提供和使用的风险，包括但不限于：这些信息对您的被监护人的学习可能产生不利影响；这些信息被风向标依法提供给第三方后被他人不当利用的风险；第三方向您推销产品或服务而打扰您的风险。此情况下，您同意并不可撤销地授权风向标依照本协议约定向其他机构提供您的个人信息。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("六、责任有限和免责条款")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    1、不允诺担保：本产品用户提问、回答、发言仅代表用户个人观点，与公司无关，且本产品不对用户发表的回答或评论的正确性、准确性、真实性进行保证。本产品为按现状提供，包含瑕疵及缺陷，公司不提供任何其他担保。公司不允诺其他无论是明示的还是默示的保证和担保，包括但不限于对特定目的的适销性和适应性，不侵权，以及任何出自交易过程或商业惯例的保证和条件。从公司或他处获取的任何建议或信息，不论是口头的还是书面的，都不会对公司产生本协议明确约定之外的其他保证和担保。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("\n    2、责任有限：适用法律所允许的最大范围内，不论出于何种原因，公司对用户的全部责任为用户为使用风向标的产品和服务而向公司支付的费用总额。如果公司免费向用户提供了本产品服务，则公司无义务对用户承担任何赔偿责任。任何情况下，公司不对出自本协议或与本协议有关的或与本产品的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论公司是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("3、免责：如因下所列任何原因而造成的用户资料泄露、丢失、被盗用或被篡改等，公司均有权获得免责：")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（1）任何因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力原因；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（2）任何计算机系统问题、黑客攻击、计算机病毒侵入或发作的原因；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（3）任何因网络安全问题导致的账户或银行卡信息泄露，该风险可能会给用户造成经济损失，用户承诺自行承担向侵权方追究责任及追究责任不能的后果；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（4）任何因用户个人原因导致的用户资料泄露、丢失、被盗用或被篡改等；")]), _vm._v(" "), _c('p', {
    staticClass: "txt bold"
  }, [_vm._v("（5）其他不能归责于公司的原因。")]), _vm._v(" "), _c('p', {
    staticClass: "txt-title bold"
  }, [_vm._v("七、其他")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("1、如果本产品平台上某一子服务附有单独的使用协议的，则该子服务的使用将受该单独使用协议的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("2、本协议的签订、生效、履行、争议的解决均适用中华人民共和国法律。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("3、有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交风向标所在地有管辖权的法院诉讼解决。")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("4、用户对知了家长平台的意见及建议可通过客服邮箱info@fxbjy.com与公司进行联系。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45e73fcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/licence/ParentCopyrightNotice.vue
// module id = 531
// module chunks = 2